/**
 * The memory games: /tools/memory.
 *
 * A run is three rounds of the same game at the same level. This is what the page shows about the
 * one being played — how long there is left to look, what is waiting to go back on the board, how
 * the round was scored — while the position itself lives in the board session (`boards.memory`).
 */
export const memorySlice = {
    // idle: choosing | showing: look at it | answering: your turn | checked: how it went | finished
    status: "idle",
    game: "recall",        // key of domain/memoryGames MEMORY_GAMES
    level: "normal",       // key of domain/memoryGames LEVELS
    round: 0,              // which round of the run, 1-based, 0 before it starts
    scores: [],            // the rounds already played, out of a hundred
    countdown: 0,          // seconds left to look at the position
    lineName: null,        // the opening the round was made from; only told once it may be
    tray: [],              // the pieces taken off the board, waiting to go back
    check: null,           // { score, correct, total, items } once the round has been checked
    sequence: null,        // { total, index, missed } while the moves are being repeated
    score: 0,              // the run, averaged
    xp: 0,
    saved: false,
    error: null,
};
